const shadeMatch = {};
shadeMatch.LOCAL_STORAGE_ID = 'shadeMatchResults';
shadeMatch.getLocalStorageData = function() {
  let result;
  let shadeMatchStr = localStorage.getItem(this.LOCAL_STORAGE_ID);
  if (shadeMatchStr) {
    result = JSON.parse(shadeMatchStr);
  }
  return result;
}

shadeMatch.getMostRecentLocalStorageObj = function() {
  let result;
  const shadeMatchStr = localStorage.getItem(this.LOCAL_STORAGE_ID);
  if (shadeMatchStr) {
    const shadeMatchObj = JSON.parse(shadeMatchStr);
    result = shadeMatchObj.reduce((latest, current) => {
      return current.timeStamp > latest.timeStamp ? current : latest;
    });
  }
  return result;
}

shadeMatch.setLocalStorageData = function(detail) {
  if (detail) {
    const localStorageData = this.getLocalStorageData();
    let result = [];
    const handle = detail.handle;
    if (localStorageData && localStorageData.length) {
      // remove any old product data that is stored and will soon be replaced
      result = localStorageData.filter((obj) => {
        return !(obj.handle === handle && obj.featureID === detail.featureID);
      });
    }
    result.push({
      handle: detail.handle, // product handle
      barcode: detail.barcode, // use barcode to handle possible 3rd party data
      featureID: detail.featureID, // string ex. 'vto' or 'findation'
      timeStamp: Date.now()
    });
    localStorage.setItem(this.LOCAL_STORAGE_ID, JSON.stringify(result));

    shadeMatch.populateShadeMatchSection();

    // guards shade update
    if (detail.featureID !== 'findation'){
      shadeMatch.selectShadeByTitle();
    }
  }
}


// Custom event listener for 'shadeMatch:setData'
document.body.addEventListener('shadeMatch:setData', (e) => {
  if (e.detail) {
    shadeMatch.setLocalStorageData(e.detail);
  }
});

shadeMatch.selectShadeByTitle = function(){
  const shadeMatchResults = document.getElementById('shade-match-results');
  const container = shadeMatchResults?.closest('.product__info-container');
  const slides = container?.querySelectorAll('.swatches-carousel-container .swiper-slide');
  const variantSelects = container?.querySelector('variant-selects');
  const shadeName = shadeMatchResults?.dataset.shadeName;

  if (shadeMatchResults && shadeName && slides) {
    for (const slide of slides) {
      const label = slide.querySelector('label[title]');
      if (label && label.title.trim().toLowerCase() === shadeName.trim().toLowerCase()) {
        label.click();
        variantSelects?.goToSelectedSlide();
        return; 
      }
    }
  }
}

shadeMatch.isShadeMatchSectionPopulated = function() {
  const container = document.getElementById('shade-match-results');
  return container?.classList?.contains('shade-match-populated');
}

shadeMatch.populateShadeMatchSection = function() {
  if (typeof shadeMatch === 'undefined') {
    return;
  }
  const recent = shadeMatch.getMostRecentLocalStorageObj();  
  if (!recent || !recent.barcode) {
    return;
  }

  const barcode = String(recent.barcode);
  const variantData = window.variantMetafieldsByBarcode?.[barcode];  
  if (!variantData) {
    return;
  }
  const { shade_swatch: swatchUrl, title: shadeName } = variantData;
  const container = document.getElementById('shade-match-results');
  const resultImage = document.querySelector('.result-shade-image');
  const resultName = document.querySelector('.result-shade-name');
  let hasContent = false;
  if (swatchUrl && resultImage) {
    resultImage.src = swatchUrl;
    resultImage.style.display = 'block';
    hasContent = true;
    container.classList.add('shade-match-populated');
    container.dataset.shadeName = shadeName;
  }
  if (shadeName && resultName) {
    resultName.textContent = shadeName;
    hasContent = true;
  }

  if (hasContent && container) {
    container.style.display = 'block';
  }
}
